<template>
  <textarea :id="thisId">

  </textarea>
</template>

<script>
import 'tinymce'
/*
import 'tinymce/themes/modern/theme.js'
import 'tinymce/skins/lightgray/skin.min.css'
import 'tinymce/skins/lightgray/content.min.css'
import 'tinymce/plugins/advlist/plugin.js'
import 'tinymce/plugins/autolink/plugin.js'
*/
import Vue from 'vue'
	Vue.directive('tinymce-teras',{ 
  	twoWay: true,
    inserted: function(el, binding, vnode) {
    	var self = el
      var selec = el.id
      console.log("CI ARRIVO ")
      console.log(this)
      tinymce.init({
      	selector: '#'+el.id,
        setup: function(editor) {
        console.log("SETUP TINYMCE______________-")
        console.log(el.value)
        	// init tinymce
        	editor.on('init', function() {
            if(el.value!='')
                tinymce.get(el.id).setContent(el.value);
          });
          
          // when typing keyup event
          editor.on('keyup change', function(e) {
          	//console.log(el.id)
            // get new value
          	var new_value = tinymce.get(el.id).getContent();
            //console.log(new_value)
            // set model value
            el.value = new_value
            
            //console.log(el.value)
          });
          
        }
      });
    },
    unbind:function(){
      tinymce.remove()
    },
    update: function(newVal, oldVal) {
    	// set val and trigger event
    	//$(this.el).val(newVal).trigger('keyup');
      console.log(newVal)
    }
  
  })


export default {
  props: ['height'],
  created () {
    console.log("TINYMCE CREATO");
    this.thisId="tinymce-"+Math.floor((Math.random() * 10000) + 1)
  },  
  mounted (){
    var self = this
    console.log("MOUNTED TINYMCE "+this.height)
    console.log(self.$el.id)
    tinyMCE.baseURL = "https://cdn.tinymce.com/4"
    this.tiny = tinymce.init({
      	selector: '#'+self.$el.id,
        menubar: false,
        height: self.height,
        //relative_urls : false,
        //document_base_url: "http://cdn.tinymce.com/4",

        plugins: [
          'advlist autolink lists link image charmap print preview hr anchor pagebreak',
          'searchreplace wordcount visualblocks visualchars code fullscreen',
          'insertdatetime media nonbreaking save table contextmenu directionality',
          'emoticons template paste textcolor colorpicker textpattern imagetools codesample toc'
        ],
        toolbar1: 'undo redo |  styleselect | bold italic | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
        //toolbar2: 'insert | print preview media | forecolor backcolor emoticons | codesample',

        setup: function(editor) {
        console.log("SETUP TINYMCE")
        console.log(self.$el.id)
        	// init tinymce
        	editor.on('init', function() {
            //tinymce.get(self.$el.id).setContent();
          });
          
          // when typing keyup event
          editor.on('keyup change', function(e) {
          	var new_value = tinymce.get(self.$el.id).getContent();
            self.$el.value = new_value
            self.$emit('input', new_value);
            self.$emit('change', new_value);

            //console.log(el.value)
          });
          
        }
      })
      console.log(this.tiny)
      console.log("FINITA")
  },
  destroyed(){
    tinymce.remove()
  },
  
}

</script>
<style>
.inside-top{
  background:#fff url(/2017/documenti/backInside.png) no-repeat center center;
  width: 100%;
  height:275px;
  border-top:2px solid #fff;
}
.page-inside{

}
.page-inside h3.title{
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// _Tinymce.vue?25e1a9dd